import $apiJSON from '../http/apiJSON'

export async function createFeedback(data) {
  return $apiJSON.post('feedback/create/', data)
}

class FeedbackService {
    static createFeedback = createFeedback
}

export default FeedbackService
